import '@recruitee/redactor';
import '@recruitee/redactor/_plugins/alignment/alignment.js';
import '@recruitee/redactor/_plugins/fontcolor/fontcolor.js';
import '@recruitee/redactor/_plugins/fontsize/fontsize.js';
import '@recruitee/redactor/_plugins/variable/variable.js';
import '@recruitee/redactor/_plugins/video/video.js';
